import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hideandskindemand',
  templateUrl: './hideandskindemand.component.html',
  styleUrls: ['./hideandskindemand.component.scss']
})
export class HideandskindemandComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
